import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { FilterCompleteService, IFilterComplete } from '../../../filter-complete/filter-complete';
import { ReservationService } from '../../../services/reservation.service';
import { PatientSearch } from '../../../model/patient/patient-search';
import { Data } from '@angular/router';
import { IFilterComponent, SearchFilter } from '../../../infrastructure/iFilter-component';
import { FilterService } from '../../../services/filter.service';
import { ServiceFilter } from '../../../model/service-filter';
import { PhysicianFilter } from '../../../model/physician-Filter';
import { PracticeRegionFilter } from '../../../model/practice-region-filter';
import { CenterFilter } from '../../../model/center-filter';
import { EquipmentFilter } from '../../../model/equipment-filter';
import { FilterRecordService } from '../../../services/filter-record.service';
import { Entity, Plan } from '../../../model/entity';

@Component({
  selector: 'app-reservation-inconsistent-filter-component',
  templateUrl: './reservation-inconsistent-filter.component.html',
  styleUrls: ['./reservation-inconsistent-filter.component.css']
})
export class ReservationInconsistentFilterComponent implements IFilterComponent, OnInit {

  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;
  filterCompletePhysicians: FilterCompleteService<PhysicianFilter>;
  filterCompleteEquipments: FilterCompleteService<EquipmentFilter>;
  filterCompleteEntities: FilterCompleteService<Entity>;
  filterCompletePlan: FilterCompleteService<Plan>;
  form: FormGroup;

  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private filterRecordService: FilterRecordService
    , private reservationService: ReservationService) {

    this.form = this.formBuilder.group({
      DateFrom: [new Date(), [Validators.required]],
      DateTo: [new Date(), [Validators.required]],
      Patient: [null],
      Physician: [''],
      Service: [''],
      Equipment: [''],
      Entity: [''],
      Plan: [''],
    });

    this.filterCompletePlan = new FilterCompleteService<Plan>([], this.form.controls.Plan);
    this.filterCompleteEquipments = new FilterCompleteService<EquipmentFilter>([], this.form.controls.Equipment);
    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>([], this.form.controls.Physician);
    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>([], this.form.controls.Service);
    this.filterCompleteEntities = new FilterCompleteService<Entity>([], this.form.controls.Entity);
  }

  get filteredPlanOptions() { return this.filterCompletePlan ? this.filterCompletePlan.filteredOptions : []; }
  get filteredEntitiesOptions() { return this.filterCompleteEntities ? this.filterCompleteEntities.filteredOptions : []; }
  get filteredEquipmentsOptions() { return this.filterCompleteEquipments ? this.filterCompleteEquipments.filteredOptions : []; }
  get filteredPhysiciansOptions() { return this.filterCompletePhysicians ? this.filterCompletePhysicians.filteredOptions : []; }
  get filteredServicesOptions() { return this.filterCompleteServices ? this.filterCompleteServices.filteredOptions : []; }
  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push('DateFrom');
    requiredTags.push('DateTo');
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async entitySelected(entity: Entity) {
    if (entity) {
      this.filterCompletePlan =
      new FilterCompleteService<Plan>((await this.filterService.getPlanFilter(entity.Id)), this.form.controls.Plan);
    }
  }

  onEntityChange(): void {
    this.form.patchValue({ Plan: null });
    this.filterCompletePlan = new FilterCompleteService<Plan>([], this.form.controls.Plan);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('ReservationInconsistentFilterComponent', this.form);
    const entityId = this.form.controls.Entity.value ? (<Entity>this.form.controls.Entity.value).Id : null;
    if (entityId) {
      this.filterCompletePlan =
      new FilterCompleteService<Plan>((await this.filterService.getPlanFilter(entityId)), this.form.controls.Plan);
    }
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('ReservationInconsistentFilterComponent', this.form);
  }

  async search(): Promise<any> {
    return await this.reservationService.getReservationSearchItemsForInconsistent(
      <Date>this.form.controls.DateFrom.value
      , <Date>this.form.controls.DateTo.value
      , (this.form.controls.Patient.value ? (<PatientSearch>this.form.controls.Patient.value).Id : null)
      , (this.form.controls.Equipment.value ? (<EquipmentFilter>this.form.controls.Equipment.value).Id : null)
      , (this.form.controls.Service.value ? (<ServiceFilter>this.form.controls.Service.value).Id : null)
      , (this.form.controls.Physician.value ? (<PhysicianFilter>this.form.controls.Physician.value).Id : null)
      , (this.form.controls.Entity.value ? (<Entity>this.form.controls.Entity.value).Id : null)
      , (this.form.controls.Plan.value ? (<Plan>this.form.controls.Plan.value).Id : null));
  }

  async ngOnInit() {
    this.filterCompleteServices =
    new FilterCompleteService<ServiceFilter>((await this.filterService.getServicesFilter()), this.form.controls.Service);
    this.filterCompletePhysicians =
    new FilterCompleteService<PhysicianFilter>((await this.filterService.getPhysiciansFilter()), this.form.controls.Physician);
    this.filterCompleteEquipments =
    new FilterCompleteService<EquipmentFilter>((await this.filterService.getEquipmentsFilter()), this.form.controls.Equipment);
    this.filterCompleteEntities =
    new FilterCompleteService<Entity>((await this.filterService.getEntitiesFilter(true)), this.form.controls.Entity);
  }
}
